// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBYD4N5OlfPyct1ggsv9hY94jH154zTzSE",
  authDomain: "medicino-patient-6cda3.firebaseapp.com",
  projectId: "medicino-patient-6cda3",
  storageBucket: "medicino-patient-6cda3.appspot.com",
  messagingSenderId: "73854375500",
  appId: "1:73854375500:web:3a54a33f7ef8d185f806e9",
  measurementId: "G-W2XM0MY01T"
};

// // init firebase
// initializeApp(firebaseConfig)

// // init firestore service
// const db = getFirestore()
// export default db

// Initialize Firebase
firebase.initializeApp(firebaseConfig);


// Initialize Cloud Firestore and get a reference to the service
const db = firebase.firestore();
export default db;
